//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"Depth",1,0],[0,"DepthBuilder",0,"CAM.InferredDouble",0],[0,"DepthLimit",1,0],[0,"Diameter",1,0],[0,"DiameterBuilder",0,"CAM.InferredDouble",0],[0,"Length",1,0],[0,"LengthBuilder",0,"CAM.InferredDouble",0],[0,"MajorDiameter",1,0],[0,"MinorDiameter",1,0],[0,"Size",1,0],[0,"StartDiameter",0,"CAM.CAMAttribute",0],[0,"TipAngle",0,"CAM.CAMAttribute",0],[0,"ToolAxis",1,"NXObject",0]],[[["entity"],"InferLogic",{},1,0],[[],"ReverseDirection",{},0,0],[[],"GetFeature",{R_:{tagFeature:"CAM.FBM.Feature"}},0,0],[[],"GetMachiningFeature",{R_:{tagFeature:"CAM.CAMFeature"}},0,0]],[]];
SPLM.CAM.HoleBossSet = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.HoleBossSet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.HoleBossSet.DepthLimitTypes = Object.freeze({
    "Through" : "Through", "Blind" : "Blind"});

export default SPLM;